(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hol-cro-content"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('hol-editorial')) {
  customElements.define('hol-editorial', class extends HTMLElement {
    connectedCallback() {
      this.events?.abort();
      this.events = new AbortController();
      const options = {signal:this.events.signal};
      const rail = this.querySelector('.hol-editorial__reels');
      if (!rail) return;
      const dialog = this.querySelector('dialog');
      const embed = this.querySelector('.hol-editorial__embed');
      const previous = this.querySelector('[data-reel-prev]');
      const next = this.querySelector('[data-reel-next]');
      const update = () => {
        previous.disabled = rail.scrollLeft <= 2;
        next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 3;
      };
      const shift = direction => rail.scrollBy({left:direction * (rail.firstElementChild.getBoundingClientRect().width + parseFloat(getComputedStyle(rail).gap)),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      previous.addEventListener('click',()=>shift(-1),options);
      next.addEventListener('click',()=>shift(1),options);
      rail.addEventListener('scroll',update,{...options,passive:true});
      this.observer = new ResizeObserver(update);
      this.observer.observe(rail);
      this.addEventListener('click',event=>{
        const trigger = event.target.closest('[data-reel-url]');
        if (!trigger) return;
        let url;
        try { url = new URL(trigger.dataset.reelUrl); } catch { return; }
        if (!['www.instagram.com','instagram.com'].includes(url.hostname)) return;
        const match = url.pathname.match(/^\/(?:holadayco\/)?(?:reel|p)\/([A-Za-z0-9_-]+)\/?$/);
        if (!match) return;
        this.lastTrigger = trigger;
        const frame = document.createElement('iframe');
        frame.src = `https://www.instagram.com/reel/${match[1]}/embed/`;
        frame.title = trigger.dataset.reelTitle;
        frame.allow = 'autoplay; fullscreen; encrypted-media; picture-in-picture';
        frame.referrerPolicy = 'strict-origin-when-cross-origin';
        frame.allowFullscreen = true;
        embed.replaceChildren(frame);
        this.querySelector('[data-reel-fallback]').href = url.href;
        dialog.showModal();
      },options);
      this.querySelector('[data-reel-close]').addEventListener('click',()=>dialog.close(),options);
      dialog.addEventListener('click',event=>{if(event.target===dialog) dialog.close();},options);
      dialog.addEventListener('close',()=>{embed.replaceChildren();this.lastTrigger?.focus();},options);
      update();
    }
    disconnectedCallback() { this.events?.abort();this.observer?.disconnect();this.querySelector('dialog')?.close(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hol-hero-slideshow"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('hol-hero-carousel')) {
  customElements.define('hol-hero-carousel', class extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.dots = [...this.querySelectorAll('[data-dot]')];
      this.index = 0;
      this.userPaused = false;
      this.hovered = false;
      this.focused = false;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.querySelector('[data-prev]')?.addEventListener('click', () => this.show(this.index - 1), { signal });
      this.querySelector('[data-next]')?.addEventListener('click', () => this.show(this.index + 1), { signal });
      this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.show(index), { signal }));
      this.querySelector('[data-pause]')?.addEventListener('click', () => {
        this.userPaused = !this.userPaused;
        this.updatePause();
        this.schedule();
      }, { signal });
      this.addEventListener('mouseenter', () => { this.hovered = true; this.schedule(); }, { signal });
      this.addEventListener('mouseleave', () => { this.hovered = false; this.schedule(); }, { signal });
      this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, { signal });
      this.addEventListener('focusout', (event) => { this.focused = this.contains(event.relatedTarget); this.schedule(); }, { signal });
      document.addEventListener('visibilitychange', () => this.schedule(), { signal });
      this.motion.addEventListener('change', () => this.schedule(), { signal });
      this.addEventListener('touchstart', (event) => { this.touchX = event.touches[0].clientX; }, { passive: true, signal });
      this.addEventListener('touchend', (event) => {
        const distance = event.changedTouches[0].clientX - this.touchX;
        if (Math.abs(distance) > 50) this.show(this.index + (distance < 0 ? 1 : -1));
      }, { passive: true, signal });
      document.addEventListener('shopify:block:select', (event) => {
        const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
        if (index >= 0) { this.userPaused = true; this.show(index); this.updatePause(); }
      }, { signal });
      this.schedule();
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.controller?.abort();
    }
    show(index) {
      if (!this.slides.length) return;
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === this.index);
        slide.setAttribute('aria-hidden', String(i !== this.index));
      });
      this.dots.forEach((dot, i) => dot.setAttribute('aria-pressed', String(i === this.index)));
      this.schedule();
    }
    updatePause() {
      const button = this.querySelector('[data-pause]');
      if (!button) return;
      button.setAttribute('aria-pressed', String(this.userPaused));
      button.setAttribute('aria-label', this.userPaused ? button.dataset.playLabel : button.dataset.pauseLabel);
      button.querySelector('[data-pause-icon]').hidden = this.userPaused;
      button.querySelector('[data-play-icon]').hidden = !this.userPaused;
    }
    schedule() {
      clearTimeout(this.timer);
      if (this.dataset.autoplay !== 'true' || this.slides.length < 2 || this.userPaused || this.hovered || this.focused || this.motion.matches || document.hidden) return;
      this.timer = setTimeout(() => this.show(this.index + 1), Number(this.dataset.delay) || 7000);
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
